// Signing out deletes this browser's Firestore cache (auth.js, for shared
// devices), and the cache is also where writes wait for a connection. So sign-out
// asks first when anything is still waiting (v4.38.11). Pure: no Firebase here.

export const LOSS_COPY = {
  title: 'Some of your work hasn’t been sent',
  body: 'Work you did on this device hasn’t reached the server yet. If you sign out now it will be lost. Stay signed in and get back online, and it will send by itself.',
  stay: 'Stay signed in',
  go: 'Sign out anyway',
};

/**
 * Is anything still queued? `wait` is Firestore's waitForPendingWrites, which only
 * resolves once the server has everything, so offline it never does: hence the
 * race. A wait that fails is treated as "yes": a needless question costs one click,
 * a wrong "no" costs the work.
 */
export async function unsentWrites(wait, ms = 2000) {
  let timer = null;
  const settled = Promise.resolve().then(wait).then(() => false, () => true);
  const out = await Promise.race([settled, new Promise((r) => { timer = setTimeout(() => r(true), ms); })]);
  clearTimeout(timer);
  return out;
}

/**
 * What sign-out does about the cache.
 *   force      a closed account: its writes can never be delivered, and clearing
 *              this device is the security behaviour. Never asks, always clears.
 *   automatic  nobody is there to ask: sign out, but keep the cache when work is
 *              queued (Firestore keeps it per person, so it sends when they next sign in).
 *   otherwise  ask when work is queued.
 */
export function signOutPlan({ pending = false, automatic = false, force = false } = {}) {
  if (force) return { ask: false, clearCache: true };
  if (!pending) return { ask: false, clearCache: true };
  if (automatic) return { ask: false, clearCache: false };
  return { ask: true, clearCache: true };
}
